import React from 'react'
import { FormControl, FormHelperText, InputLabel, Select } from '@material-ui/core'

interface SelectFieldProps {
  name: string
  // etiqueta visible (no usar solo placeholder)
  label: string
  value: string | number
  helperText?: string
  disabled?: boolean
  required?: boolean
  // <MenuItem> hijos
  children: React.ReactNode
}

// Select outlined con etiqueta y texto de ayuda. Ocupa todo el ancho de su columna.
export default function SelectField({ name, label, value, helperText, disabled, required, children }: SelectFieldProps) {
  const labelId = `${name}-label`

  return (
    <FormControl variant="outlined" fullWidth disabled={disabled} required={required}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select labelId={labelId} label={label} name={name} value={value}>
        {children}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}
